<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.quiz.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineQuizForm :quiz="quiz" :APIbaseURL="APIbaseURL" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineQuizForm from '@/components/AveineQuizForm.vue'
import Quiz from '@/store/models/quiz'
import { errorHandler } from 'aveine-toolbox'

export default {
  name: 'Update',
  components: { AveineQuizForm },
  data () {
    return {
      quiz: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    try {
      await Quiz.api().get(
        `quizzes/${this.$route.params.id}?lang=${this.$i18n.locale}`,
        { baseURL: this.APIbaseURL, params: { include: 'answers' } }
      )
      // `withAllRecursive` : sans lui, `answers` reste une liste d'identifiants
      // et le formulaire s'ouvrirait sur un quizz sans reponses.
      this.quiz = Quiz.query().whereId(this.$route.params.id).withAllRecursive().first()
      this.dataLoaded = true
    } catch (errors) {
      this.dataLoaded = true
      errorHandler(errors, this)
    }
  }
}
</script>
